import { useViewportScroll, useTransform } from "framer-motion"

export function useRotateOnScroll(dampening: number) {
	const { scrollY } = useViewportScroll()
	const rotate = useTransform(scrollY, (value) => value / dampening)

	return rotate
}
